import React from 'react'

const NoRecordsFound = () => {
  return (
    <div className="flex justify-center my-5"><p className="font-semibold text-lg">No records found</p></div>
  )
}

export default NoRecordsFound